import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations } from 'vuex';
import mixinActionBoxStyles from '@/components/core/mixinActionBoxStyles';
import EditMixin from '@/components/core/dtwin/editMixin';
import GeoDataMixin from '@/components/core/dtwin/geoDataMixin';
import get from 'lodash/get';

var defaultTab = function defaultTab(ctx) {
  if (ctx.$route.query.stateId) {
    return 'tab-states';
  }

  if (ctx.$route.query.ruleId) {
    return 'tab-rules';
  }

  if (ctx.$route.query.main !== undefined) {
    return 'tab-main';
  }

  return 'tab-dasbhoard';
};

export default {
  name: 'ViewISHeatMonitoringMeterPointDetails',
  mixins: [EditMixin, GeoDataMixin, mixinActionBoxStyles],
  data: function data() {
    return {
      twinSelectionTreeMenu: true,
      pageYOffset: 0,
      tabItem: defaultTab(this),
      shouldOpenStateDetail: !!this.$route.query.stateId
    };
  },
  computed: {
    headerBG: function headerBG() {
      if (get(this.twinObject, 'data.twinImageId')) {
        return "".concat(process.env.VUE_APP_API_HOST).concat(process.env.VUE_APP_API_PATH, "/upload/").concat(this.twinObject.data.twinImageId);
      }

      return null;
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    exportButtonDetails: function exportButtonDetails() {
      return {
        icon: 'fal fa-file-pdf',
        action: 'exportModal',
        tooltip: 'Core.ExportDialog.titleTextPdf'
      };
    },
    stateSourcesNameMapping: function stateSourcesNameMapping() {
      return {
        'virtual-device': this.$i18n_t('IS.HeatMonitoring.drawer.isHeatMonitoringMeters'),
        'virtual-device-aggregate': "".concat(this.$i18n_t('IS.HeatMonitoring.drawer.isHeatMonitoringMeters'), " ").concat(this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.aggregate'))
      };
    }
  },
  watch: {
    twinDataStates: function twinDataStates() {
      if (this.twinDataStates.length) {
        if (this.shouldOpenStateDetail && this.$refs['stateTable']) {
          this.finishedLoadingStatesTable();
        }
      }
    },
    $route: function $route() {
      // the component is not reloaded/re-mounted if the twin-id in the route changes
      // so perform the setup again for a different route; i.e. swap out the displayed details on-the-fly
      this.teardownDtwinSocket();
      this.setup();

      if (get(this.$route, 'query.stateId')) {
        this.tabItem = 'tab-states';
      } else if (get(this.$route, 'query.ruleId')) {
        this.tabItem = 'tab-rules';
      }
    }
  },
  created: function created() {
    this.baseLink = 'is-heatmonitoring/meter-points';
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.saveScrollOffset);
    this.setup();
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.saveScrollOffset);
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    digitalTwinChanged: function digitalTwinChanged(selection) {
      if (parseInt(selection.id) !== parseInt(this.$route.params.id)) {
        this.$router.push("/is-heatmonitoring/meter-points/".concat(selection.id));
        this.twinSelectionTreeMenu = false;
      }

      this.twinSelectionTreeMenu = false;
    },
    breadCrumbsPath: function breadCrumbsPath() {
      var ancestorList = this.ancestorList();

      if (ancestorList.length) {
        return ancestorList.map(function (a) {
          return {
            to: a.parentId === null ? "/digitaltwin-mgmt/".concat(a.id) : "/is-heatmonitoring/meter-points/".concat(a.id),
            text: a.parentId === null ? a.title : a.id
          };
        });
      }

      return [{
        to: '/is-heatmonitoring/meter-points',
        text: this.$i18n_t('Common.drawer.dTwins')
      }];
    },
    saveScrollOffset: function saveScrollOffset() {
      this.pageYOffset = window.pageYOffset;
    },
    finishedLoadingStatesTable: function finishedLoadingStatesTable() {
      var _this = this;

      if (this.$route.query.stateId) {
        this.$nextTick(function () {
          var state = _this.twinDataStates.find(function (s) {
            return s.id === parseInt(_this.$route.query.stateId);
          });

          if (state) {
            _this.shouldOpenStateDetail = false;

            _this.$refs['stateTable'].editState(state);
          }
        });
      }
    },
    didUpdateStates: function didUpdateStates() {
      this.refreshStates();
    },
    dialogDisable: function dialogDisable() {
      this.dtwinToggleState();
    },
    prepareSubmit: function prepareSubmit() {
      this.handleSubmit();
    },
    finishedTwinSetup: function finishedTwinSetup() {
      if (this.twinObject.data.keyValue['Customer ID'] === undefined) {
        this.twinObject.data.keyValue['Customer ID'] = '';
      }
    }
  })
};